'use strict';
window.uomedia = window.uomedia || {};

(($) => {

  const closeAllSubnavs = () => {
    $('nav.nav-primary .menu-item-has-children').removeClass('subnav-open');
    $('nav.nav-primary .sub-menu').removeClass('d-block');
    $('nav.nav-primary .menu-item-has-children > a').attr('aria-expanded', 'false');
  };

  const $subnavParents = $('#header .menu-item-has-children > a');

  $subnavParents.on('click', function (event) {
    // only interrupt if this has '#' and aria roles
    const $this = $(this);
    if ($this.attr('href') === '#') {
      event.preventDefault();
      event.stopPropagation(); // accounts for nested subnavs
      const $nav = $this.parent('li');
      closeAllSubnavs();
      $nav.toggleClass('subnav-open');
      $this.attr('aria-expanded', $nav.hasClass('subnav-open') ? 'true' : 'false');
    }
  });

  // hide open nav when focusing into a new one
  $subnavParents.on('focus', function () {
    const $this = $(this);
    $('.menu-item-has-children').not($this).removeClass('subnav-open');
    $('.sub-menu').not($this).removeClass('d-block');
  });

  // close any open nav when non-nav items are clicked.
  $('body').on('click', function (event) {
    const $target = $(event.target);
    if ($target.closest('nav').length) {
      return;
    } else {
      $('.menu-item-has-children').removeClass('subnav-open');
      $('.sub-menu').removeClass('d-block');
    }
  });

  // close any nav items
  $('a.brand, #searchform input').on('focus', function () {
    closeAllSubnavs();
  });

  // hide any open nav when search is clicked.
  $('#top-search a').on('click', function () {
    closeAllSubnavs();
  });

})(jQuery);
